import React, { PureComponent } from 'react';

type TabButtonProps = {
  text?: string;
  // The text chosen by the tab: « Mettre à jour » on the button that sends an update, never on « Onglet précédent »
  label: string;
  disabled?: boolean;
  onClick?: (e: any) => void;
  style?: Record<string, any>;
  // Extra class on the button, e.g. `af-form-button--previous` for the « Onglet précédent » button
  buttonClassName?: string;
};

class TabButton extends PureComponent<TabButtonProps> {
  render() {
    const { text, label, disabled, onClick, style = {}, buttonClassName, ...props } = this.props;
    // Text or label, legacy...
    const buttonLabel = label || text;
    return (
      <div style={style} className="af-container" {...props}>
        <button type="submit" className={buttonClassName ? `af-form-button ${buttonClassName}` : 'af-form-button'} onClick={onClick} disabled={disabled}>
          {buttonLabel || 'Submit'}
        </button>
      </div>
    );
  }
}

export { TabButton };
